<script lang="ts">
  // Presentation manager already exists at /my-profile/presentations and has its
  // own full-page UI. This tab acts as an entry point + summary so that
  // creators can jump in from the unified profile editor without losing
  // navigation context.
</script>

<section class="space-y-6">
  <header class="rounded-3xl border border-gray-200 bg-white p-6">
    <p class="text-xs font-semibold uppercase tracking-[0.24em] text-sky-600">Presentation</p>
    <h2 class="mt-2 text-2xl font-semibold text-gray-950">프레젠테이션 관리</h2>
    <p class="mt-2 max-w-2xl text-sm leading-6 text-gray-600">
      프로필에 임베드되는 슬라이드 / 프레젠테이션을 관리합니다. 관리 도구는 별도 페이지에서 열립니다.
    </p>
    <div class="mt-5 flex flex-wrap gap-2">
      <a
        href="/my-profile/presentations"
        class="inline-flex items-center justify-center rounded-full bg-gray-950 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-gray-800"
      >
        프레젠테이션 매니저 열기 →
      </a>
    </div>
  </header>

  <div class="rounded-3xl border border-dashed border-gray-300 bg-gray-50 p-8 text-center">
    <p class="text-sm text-gray-500">
      이 자리에 곧 프레젠테이션 미리보기와 통계가 표시될 예정입니다.
    </p>
  </div>
</section>
